import classnames from 'classnames';
import { NoDataComponent, WaitingScreen } from '@/shared/ui';
import EditStripBox from '../editStripBox';
import StripEvents from '../stripEvents';
import StripImageViewer from '../stripImageViewer';
import StripsActionButton from '../stripsActionButton';
import useManageStripsWrapper from './useManageStripsWrapper';

export type ManageStripsWrapperProps = {
  reportData?: any;
  isActive?: boolean;
  isNotEdit?: boolean;
  studyId?: any;
  profileId?: any;
};

/**
 * Layout for the AI-captured strips half of the strips management tab. useManageStripsWrapper supplies the active action button, ECG data map, timezone offset and the waiting and empty-tab flags, which select between a waiting screen, a no-data panel, and the action bar, thumbnail grid, edit pane and strip image viewer.
 *
 * @param props - Wrapper props carrying the report data plus the tab-active and read-only flags.
 * @returns The rendered strips layout, the waiting screen, or the no-data panel.
 */
const ManageStripsWrapper = ({
  reportData,
  isActive,
  isNotEdit,
  studyId,
  profileId,
}: ManageStripsWrapperProps) => {
  const { activeButton, ecgDataMap, timezoneOffset, emptySelectedKey, isWaiting, isShowTabHeader } =
    useManageStripsWrapper({ reportData, isActive, studyId, profileId });

  return (
    <div
      className={classnames(
        'rhythm-event-content strip-management-content',
        !isShowTabHeader ? 'is-hide-header' : '',
      )}
    >
      {isWaiting ? (
        <WaitingScreen />
      ) : emptySelectedKey?.isEmptyTab ? (
        <NoDataComponent />
      ) : (
        <>
          <StripsActionButton isNotEdit={isNotEdit} />
          <StripEvents />
          <div id="strip-info" className="strip-events-content-container --min-width-strip-event">
            <div className="event-select-ecg-viewer-wrapper">
              <EditStripBox isActive={isActive} />
              <StripImageViewer
                reportData={reportData}
                ecgDataMap={ecgDataMap}
                timezoneOffset={timezoneOffset}
                activeButton={activeButton}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ManageStripsWrapper;
